import { render, staticRenderFns } from "./ViewerHeaderCover.vue?vue&type=template&id=0559e7b3&scoped=true"
import script from "./ViewerHeaderCover.vue?vue&type=script&lang=js"
export * from "./ViewerHeaderCover.vue?vue&type=script&lang=js"
import style0 from "./ViewerHeaderCover.vue?vue&type=style&index=0&id=0559e7b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0559e7b3",
  null
  
)

export default component.exports